import React from 'react'

const UserLoading = () => {
  return (
    <div></div>
  )
}

export default UserLoading